import { render, staticRenderFns } from "./guardianWizard.vue?vue&type=template&id=015f1bb1&scoped=true"
import script from "./guardianWizard.vue?vue&type=script&lang=js"
export * from "./guardianWizard.vue?vue&type=script&lang=js"
import style0 from "./guardianWizard.vue?vue&type=style&index=0&id=015f1bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015f1bb1",
  null
  
)

export default component.exports